import { SCORE_TIER_COLOR, SCORE_TIER_BG, SCORE_TIER_LABEL } from '../utils/amplitude.js';

/**
 * Colored score badge. Hover tooltip shows full breakdown.
 * Props: score (int), tier (string), breakdown (object), showLabel (bool)
 */
export default function AmplitudeScoreChip({ score, tier, breakdown, showLabel = false }) {
  const tip = breakdown
    ? `Engagement score: ${score}/100\n` +
      `Recency: ${breakdown.recencyPts}/30 — ${breakdown.recencyLabel}\n` +
      `Volume: ${breakdown.volumePts}/25 — ${breakdown.recentMsgs} msgs\n` +
      `Trend: ${breakdown.trendPts}/25 — ${breakdown.trendLabel}\n` +
      `Consistency: ${breakdown.consistencyPts}/20 — ${breakdown.activeCount}/${breakdown.monthsInSystem ?? 6} months active`
    : `Score: ${score}/100`;

  return (
    <span
      title={tip}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 3,
        background: SCORE_TIER_BG[tier],
        color: SCORE_TIER_COLOR[tier],
        borderRadius: 4, padding: '1px 6px',
        fontSize: 11, fontWeight: 700,
        flexShrink: 0, whiteSpace: 'nowrap',
        cursor: 'default',
      }}
    >
      {score}
      {showLabel && (
        <span style={{ fontWeight: 400 }}> {SCORE_TIER_LABEL[tier]}</span>
      )}
    </span>
  );
}
